import { render } from "./LcTitleIcon.vue?vue&type=template&id=0704f17e&scoped=true"
import script from "./LcTitleIcon.vue?vue&type=script&lang=js"
export * from "./LcTitleIcon.vue?vue&type=script&lang=js"

import "./LcTitleIcon.vue?vue&type=style&index=0&id=0704f17e&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0704f17e"]])

export default __exports__